module.exports = __webpack_public_path__ + "img/connections.fed65975.png";